import { hubService } from './HubService';

function easeOutCubic(t: number): number {
  const u = 1 - t;
  return 1 - u * u * u;
}

/**
 * Drives `hubService.bubbleProgress` from 0 to 1 over `durationMs`, then
 * resolves. Frame-driven via rAF; eases out so the reveal settles softly.
 */
export function animateBubbleProgress(durationMs: number): Promise<void> {
  return new Promise<void>((resolve) => {
    const start = performance.now();
    const step = (now: number) => {
      const t = Math.min(1, (now - start) / durationMs);
      hubService.bubbleProgress = easeOutCubic(t);
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        hubService.bubbleProgress = 1;
        resolve();
      }
    };
    requestAnimationFrame(step);
  });
}
